<template>
  <svg v-if="isCopied" width="100%" height="100%" viewBox="0 0 18 18" class="text-success" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.6 9 L7.2 12.6 L13.5 5.4" fill="none" stroke="currentColor" stroke-width="1.245" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg v-else width="100%" height="100%" viewBox="0 0 18 18" class="fill-current" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.125 6V6C12.4732 6 12.6473 6 12.7943 6.01084C14.7713 6.15668 16.3433 7.72866 16.4892 9.70574C16.5 9.85267 16.5 10.0268 16.5 10.375V11.25C16.5 12.4122 16.5 12.9934 16.3801 13.4719C16.0215 14.9036 14.9036 16.0215 13.4719 16.3801C12.9934 16.5 12.4122 16.5 11.25 16.5H10.375C10.0268 16.5 9.85267 16.5 9.70574 16.4892C7.72866 16.3433 6.15668 14.7713 6.01084 12.7943C6 12.6473 6 12.4732 6 12.125V12.125M6.75 12V12C7.91224 12 8.49335 12 8.97192 11.8801C10.4036 11.5215 11.5215 10.4036 11.8801 8.97192C12 8.49335 12 7.91224 12 6.75V6.75C12 5.58776 12 5.00665 11.8801 4.52808C11.5215 3.09638 10.4036 1.9785 8.97192 1.61988C8.49335 1.5 7.91224 1.5 6.75 1.5V1.5C5.58776 1.5 5.00665 1.5 4.52808 1.61988C3.09638 1.9785 1.9785 3.09638 1.61988 4.52808C1.5 5.00665 1.5 5.58776 1.5 6.75V6.75C1.5 7.91224 1.5 8.49335 1.61988 8.97192C1.9785 10.4036 3.09638 11.5215 4.52808 11.8801C5.00665 12 5.58776 12 6.75 12Z" fill="none" stroke="currentColor" stroke-width="1.245" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CopyIcon',

  props: {
    isCopied: {
      type: Boolean,
      default: false
    }
  }
}
</script>
